import delhivery3plFieldMap from './Delhivery3plSchema';
import rapido3plFieldMap from './Rapido3plSchema';
import zomato3plFieldMap from './Zomato3plSchema';
import zepto3plFieldMap from './Zepto3plSchemaMap';
import zomatoPersonalInfoSchema from './ZomatoSchema';

const companiesSchemaMap = {
  ZOMATO_3PL: zomato3plFieldMap,
  RAPIDO_3PL: rapido3plFieldMap,
  DELHIVERY_3PL: delhivery3plFieldMap,
  ZEPTO_3PL: zepto3plFieldMap,
  ZOMATO: zomatoPersonalInfoSchema
};

export default companiesSchemaMap;
